import { createContext, PropsWithChildren, useContext } from 'react'
import { useParams } from 'react-router-dom'

const ComponentProviderContext = createContext<null | {
  componentID: string
  useUrl: boolean
}>(null)

export default function ComponentProvider(
  props: PropsWithChildren<
    { useUrl: false; componentID: string } | { useUrl: true }
  >
) {
  const { componentID: urlComponentID } = useParams()
  const componentID = props.useUrl ? urlComponentID! : props.componentID
  return (
    <ComponentProviderContext.Provider
      value={{ componentID, useUrl: props.useUrl }}
    >
      {props.children}
    </ComponentProviderContext.Provider>
  )
}

export const useComponentProvider = () => {
  const ctx = useContext(ComponentProviderContext)
  if (!ctx) {
    throw new Error(
      'useComponentProvider must be used within a ComponentProvider'
    )
  }
  return ctx
}
